/**
 * @generated SignedSource<<22d027e8e501014ff6452fe785743edc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServiceDurationInterval = "DAY" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceDetails_productizedService$data = {
  readonly duration: {
    readonly amount: number;
    readonly interval: ProductizedServiceDurationInterval;
  } | null;
  readonly price: {
    readonly timeline: string | null;
    readonly type: ProductizedServicePriceType;
  };
  readonly " $fragmentType": "ProductizedServiceDetails_productizedService";
};
export type ProductizedServiceDetails_productizedService$key = {
  readonly " $data"?: ProductizedServiceDetails_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceDetails_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceDetails_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceDuration",
      "kind": "LinkedField",
      "name": "duration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "interval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServicePrice",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "7a2ca9454d0543b5af935fe7016d934e";

export default node;
